// extracted by mini-css-extract-plugin
export default {"card":"Value_card__ioWyX","img":"Value_img__6UiBT","content":"Value_content__bhenv"};